import { createGlobalState } from 'react-hooks-global-state'

export interface AppGobalState {
    user: any | undefined
    config: any | undefined
}

export const clearStateFromLocalstorage = () => {
    window.localStorage.clear()
}

const getCurrentStateFromLocalstorage = () => {
    const stateStr = window.localStorage.getItem("global_state")
    if (stateStr)
        return JSON.parse(stateStr) as AppGobalState
    else {
        return {
            user: undefined,            
            config: undefined
        }
    }                    
}

export const updateCurrentStateInLocalstorage = (key:string, data:any) => {
    const currentState = getCurrentStateFromLocalstorage()
    localStorage.setItem("global_state", JSON.stringify(
        {
            ...currentState,
            [key]: data
        }
    ));
}

export const clearCurrentStateInLocalstorage = () => {
    localStorage.removeItem("global_state")
}

const { setGlobalState, getGlobalState, useGlobalState } = createGlobalState<AppGobalState>(getCurrentStateFromLocalstorage())

export { useGlobalState, getGlobalState, setGlobalState }